import * as React from "react"
import { ImageSeeker } from "@ui-seeker/core"


export default function PlaceholderVideoImg({ onClick, enabled=true, ...props }) {
	return <ImageSeeker
		src="/images/Video.jpg"
		onClick={onClick}
		{...props}
		sx={{
			width: 50, height: 50, cursor: enabled ? "pointer" : "not-allowed",
			...props?.sx
		}}
	/>
}